import { useTranslation } from 'react-i18next';
import {
    Text,
    VStack,
    Link,
    List,
    ListItem,
    ListIcon,
} from '@chakra-ui/react';
import { AppDialog } from '../common/AppDialog';
import { useAppStore } from '../../state/store';
import { MdCheckCircle } from 'react-icons/md';

export function HelpDialog() {
    const { t } = useTranslation();
    const isOpen = useAppStore((state) => state.helpOpen);
    const onClose = useAppStore((state) =>state.toggleHelp); return (<AppDialog isOpen={isOpen} onClose={onClose} size="lg" title={t('help.viewCubeHelp')}>
                    <VStack align="start" spacing={4}>
                        <Text>{t('help.theViewCubeIsA3DNavigationToolThatLetsYouRotateTheViewAndOrientIt')}</Text>

                        <Text fontWeight="bold">{t('help.basicUsage')}</Text>
                        <List spacing={2}>
                            <ListItem>
                                <ListIcon as={MdCheckCircle} color="green.500" />
                                <b>{t('help.clickAFaceEdgeOrCorner')}</b>{t('help.toOrientTheViewToThatPreset')}</ListItem>
                            <ListItem>
                                <ListIcon as={MdCheckCircle} color="green.500" />
                                <b>{t('help.clickAndDrag')}</b>{t('help.theViewCubeToOrbitTheModel')}</ListItem>
                            <ListItem>
                                <ListIcon as={MdCheckCircle} color="green.500" />
                                <b>{t('help.clickTheHomeIcon')}</b>{t('help.toReturnToDefaultView')}</ListItem>
                            <ListItem>
                                <ListIcon as={MdCheckCircle} color="green.500" />
                                <b>{t('help.rightClick')}</b>{t('help.theViewCubeToAccessOptionsAndSaveViews')}</ListItem>
                        </List>

                        <Text fontWeight="bold">{t('help.compass')}</Text>
                        <Text>{t('help.useTheCompassRingBelowTheViewCubeToRotateTheViewAroundTheVerticalA')}</Text>

                        <Text fontSize="sm" color="gray.500" pt={4}>
                            {t('help.bIMHelpDocumentation')}
                        </Text>
                    </VStack>
        </AppDialog>
    );
}
